<!-- 组件 -->
<template>
    <div class="sideBar">
        <div class="logo"><img src="../assets/logo.png"></div>
        <div class="device-title">设备列表</div>
        <div class="xrow ai-c jc-c">
            <a @click="back" class="return-button">
                返回首页
            </a>
        </div>
        <div class="menu mgt20 xcol ai-s jc-c">
            <div :class="[activeName === encoder.InternalModel ? 'active' : '', 'menu-item', 'xcol', 'ai-c', 'jc-s', 'active-item']"
                style="cursor: pointer;" @click="changePage(encoder)" v-for="(encoder, index) in silders" :key="index">
                <i :class="getModel(encoder.InternalModel)"></i>
                <span class=" clamp1">{{ encoder.EncoderName }}</span>
            </div>

        </div>
        <div class="menu mgt20 xcol ai-s jc-c">
            <!-- <router-link :to="{ name: encoder.InternalModel, params: { id: 'localStorage.getItem("deviceKey")' } }" class="menu-item xcol ai-c jc-s active-item" v-for="(encoder,index) in silders" :key="index">
                <i :class="encoder.InternalModel"></i>
                <span class=" clamp1">{{encoder.EncoderName}}</span>
            </router-link> -->

            <!-- <router-link :to="{ name: 'air', params: { id: localStorage.getItem('deviceKey') } }" class="menu-item xcol ai-c jc-s active-item">
                <i :class="air"></i>
                <span class=" clamp1">农田气象要素监测仪</span>
            </router-link>

            <router-link :to="{ name: 'soil', params: { id:localStorage.getItem('deviceKey')} }" class="menu-item xcol ai-c jc-s active-item" >
                <i :class="soil"></i>
                <span class=" clamp1">土壤多参数自动监测站</span>
            </router-link>

            <router-link :to="{ name: 'camera', params: { id: localStorage.getItem('deviceKey') } }" class="menu-item xcol ai-c jc-s active-item">
                <i :class="camera"></i>
                <span class=" clamp1">视频监控系统</span>
            </router-link>

            <router-link :to="{ name: 'sense', params: { id: localStorage.getItem('deviceKey') } }" class="menu-item xcol ai-c jc-s active-item">
                <i :class="sense"></i>
                <span class=" clamp1">智能感知监测站</span>
            </router-link>  -->

        </div>
    </div>
</template>

<script>
/**
 *
 */
import { mapState } from 'vuex'
import { get } from "@/utils/http";
import { deviceTypeList } from "@/utils/config.js"
import { forEach, find } from 'lodash'
export default {
    name: 'encodersidebar',
    props: {},
    data() {
        return {
            id: '',
            sid: '',
            checkoutDialog: false,
            silders: [],// deviceTypeList,
            activeName: ''
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                this.getMenuList();
                this.activeName = val.meta.type;
            }
        }
    },
    created() {
        this.getMenuList();
        this.activeName = this.$route.meta.type;
    },
    // mounted() {
    //     console.log('333--',this)
    //     console.log("wwww",this.$route)
    // },

    // computed: {
    //     ...mapState(['encoders'])
    // },
    mounted() {

    },
    methods: {
        back() {
            this.$router.push({ name: 'home' })
        },
        changePage(param) {
            const type = param.InternalModel;
            const key = localStorage.getItem("deviceKey")
            this.activeName = type;
            localStorage.setItem("activeName", type)
            this.$router.push({ path: `/encoder/${type}/${key}` });
        },
        getMenuList() {
            const components = this.$store.state.silderComponent;
            let temp = [];
            forEach(deviceTypeList, item => {
                if (components.indexOf(item.code) !== -1) {
                    temp.push(item)
                }
            });
            console.log("this.silders==", this.silders)
            this.silders = temp;

        },
        getModel(it) {
            const model = this.$store.state.model;
            if (model.indexOf("LpWAN") !== -1) {
                return "LpWAN";
            }
            return it;

        }
    }
}
</script>
<style lang='less' scoped>
.sideBar {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    overflow: hidden;
    background: #fff;
    z-index: 1000;
    width: 175px;
    border-right: 1px solid #f0f3f7;

    .logo {
        text-align: center;
        padding-top: 45px;

        img {
            width: 110px;
            height: 110px;
        }
    }
}

.menu {
    .menu-item {
        user-select: none;
        background-color: #fff;
        border-left: solid 6px #fff;
        // height: 45px;
        line-height: 20px;
        padding: 15px 10px;
        width: 100%;

        span {
            color: #1f2b4f;
            font-size: 14px;
            // display: inline-block;
        }

        i {
            // display: inline-block;
            width: 64px;
            height: 64px;
            position: relative;

            &.s-default {
                background: url(../assets/encoder/air.png) no-repeat;
                background-size: 100% 100%;
            }

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: url(../assets/encoder/default.png) no-repeat;
                background-position: center bottom;
                background-size: 70%;
                z-index: 10;
            }

            &.air::before {
                background-image: url(../assets/encoder/air.png);
            }

            &.soil::before {
                background-image: url(../assets/encoder/default.png);
            }

            &.LpWAN::before {
                background-image: url(../assets/LpWAN12png.png);
            }


            &.camera::before {
                background-image: url(../assets/encoder/soil.png);
            }

            &.sense::before {
                background-image: url(../assets/encoder/sense.png);
            }

            &.pest::before {
                background-image: url(../assets/encoder/pest.png);
            }

            &.sexual::before {
                background-image: url(../assets/encoder/sexual.png);
            }
        }

        &.active,
        &:hover {
            background-color: #e1faf1;
            border-left: solid 6px #3fcdae;

            span {
                color: #3fcdae;
                // font-weight: bold;
            }
        }

        // &.active-item,
        // &:hover {
        //     background-color: #e1faf1;
        //     border-left: solid 6px red;
        //     span {
        //         color: red;
        //         // font-weight: bold;
        //     }
        // }
    }
}

.device-title {
    display: block;
    padding-top: 14px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.return-button {
    display: inline-block;
    width: 86px;
    height: 28px;
    border-radius: 25px;
    border: solid 1px #9de6d6;
    line-height: 28px;
    color: #3fcdae;
    font-size: 13px;
    margin-top: 10px;
    text-align: center;
    cursor: pointer;

    &:hover {
        font-weight: bold;
    }
}
</style>
